import { Component, Input, OnInit } from '@angular/core';
import { FindAllUserForContactForResponseDto } from '../reseller-map.interfaces';
import { EnvironmentVariablesService } from '../../../../core/services/environment-variable-service/environment-variables.service';
import { ExposedEnvironmentVariable } from '../../../../../environments/environment-variables';
import { Router } from '@angular/router';

@Component({
  selector: 'ose-reseller-user-card',
  templateUrl: './reseller-user-card.component.html',
  styleUrls: ['./reseller-user-card.component.scss'],
})
export class ResellerUserCardComponent implements OnInit {
  @Input() data: FindAllUserForContactForResponseDto;
  defaultImage = './assets/images/kapcsolat_placeholder_profile_picture.svg';
  profilePicture: string;
  constructor(private environmentVariablesService: EnvironmentVariablesService, private router: Router) {}

  ngOnInit(): void {
    this.profilePicture = `${this.environmentVariablesService.getVar(ExposedEnvironmentVariable.PROFILKEP_URL)}/${
      this.data.nicknev
    }.jpg`;
  }
  updateErrorUrl(): void {
    this.profilePicture = this.defaultImage;
  }

  navigate(url: string): void {
    window.open(url);
  }

  onClick(): void {
    this.router.navigate([this.data.nicknev], { relativeTo: null });
  }
}
